<template>
  <div v-if="available" class="admin-ms-tool">
    <button
      type="button"
      class="admin-ms-trigger"
      :class="{ active: open }"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      <img src="/Pagina%20Welcome/logo.png" alt="" />
      <span>Admin MS</span>
      <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
    </button>

    <transition name="admin-ms-drawer">
      <section v-if="open" class="admin-ms-panel" aria-live="polite">
        <div class="admin-ms-panel-copy">
          <strong>Generatore Codici Fiscali test</strong>
          <span>
            Genera un codice valido e non presente nel database per ogni cliente
            individuato.
          </span>
        </div>

        <button
          type="button"
          class="admin-ms-generate"
          :disabled="generating || !clients.length"
          @click="generateForAll"
        >
          <i
            :class="
              generating
                ? 'fa-solid fa-spinner fa-spin'
                : 'fa-solid fa-wand-magic-sparkles'
            "
            aria-hidden="true"
          ></i>
          <span v-if="generating">
            Generazione {{ completed }}/{{ total }}
          </span>
          <span v-else>Genera e inserisci per tutti</span>
        </button>

        <p v-if="message" class="admin-ms-message" :class="{ error: failed }">
          {{ message }}
        </p>
      </section>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";

export default {
  name: "AdminMsFiscalCodeGenerator",
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      available: false,
      open: false,
      generating: false,
      completed: 0,
      total: 0,
      message: "",
      failed: false,
    };
  },
  mounted() {
    this.loadAvailability();
  },
  methods: {
    isAdminMyStudio() {
      try {
        return JSON.parse(localStorage.getItem("isAdminMyStudio") || "false");
      } catch (_error) {
        return false;
      }
    },
    async loadAvailability() {
      if (!this.isAdminMyStudio()) return;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/admin-ms/test-tools/status`
        );
        this.available = !!response.data.enabled;
      } catch (_error) {
        this.available = false;
      }
    },
    async generateForAll() {
      if (this.generating || !this.clients.length) return;

      this.generating = true;
      this.completed = 0;
      this.total = this.clients.length;
      this.message = "";
      this.failed = false;

      const excludedCodes = new Set(
        this.clients
          .map((client) =>
            String(client?.[4] || "")
              .trim()
              .toUpperCase()
          )
          .filter(Boolean)
      );

      try {
        for (let index = 0; index < this.total; index += 1) {
          const response = await axios.post(
            `${API_BASE_URL}/admin-ms/test-tools/fiscal-code`,
            { excluded_codes: Array.from(excludedCodes) }
          );
          const fiscalCode = String(response.data.fiscal_code || "").trim();
          if (!fiscalCode) {
            throw new Error("Il server non ha restituito un Codice Fiscale.");
          }

          excludedCodes.add(fiscalCode);
          this.$emit("apply-code", { index, fiscalCode });
          this.completed = index + 1;
          await this.$nextTick();
        }

        this.message = `${this.completed} Codici Fiscali test inseriti.`;
      } catch (error) {
        this.failed = true;
        this.message =
          error.response?.data?.error ||
          error.message ||
          "Generazione interrotta. Riprova.";
      } finally {
        this.generating = false;
      }
    },
  },
};
</script>

<style scoped>
.admin-ms-tool {
  position: absolute;
  z-index: 40;
  top: 1rem;
  right: 1rem;
  display: flex;
  justify-content: flex-end;
  width: min(100%, 48rem);
  margin: 0;
  pointer-events: none;
}

.admin-ms-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.48rem 0.8rem;
  border: 1px solid #d7b25c;
  border-radius: 9px;
  background: linear-gradient(135deg, #fffdf5, #fff4cf);
  box-shadow: 0 4px 12px rgba(130, 91, 18, 0.12);
  color: #6f4b0b;
  cursor: pointer;
  font-weight: 800;
  pointer-events: auto;
}

.admin-ms-trigger:hover,
.admin-ms-trigger.active {
  border-color: #b98928;
  background: linear-gradient(135deg, #fff8df, #ffe9a4);
}

.admin-ms-trigger img {
  width: 1.45rem;
  height: 1.45rem;
  object-fit: contain;
}

.admin-ms-trigger i {
  margin-left: 0.1rem;
  font-size: 0.72rem;
  transition: transform 0.2s ease;
}

.admin-ms-trigger.active i {
  transform: rotate(180deg);
}

.admin-ms-panel {
  position: absolute;
  top: calc(100% + 0.55rem);
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0.9rem 1rem;
  border: 1px solid #ecd9a8;
  border-radius: 10px;
  background: #fffdf8;
  box-shadow: 0 8px 22px rgba(88, 61, 13, 0.09);
  pointer-events: auto;
}

.admin-ms-panel-copy {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  color: #334155;
  text-align: left;
}

.admin-ms-panel-copy strong {
  color: #5f410a;
}

.admin-ms-panel-copy span {
  font-size: 0.84rem;
}

.admin-ms-generate {
  flex: 0 0 auto;
  min-width: 13.5rem;
  padding: 0.62rem 0.85rem;
  border: none;
  border-radius: 8px;
  background: #9a6a13;
  color: #fff;
  cursor: pointer;
  font-weight: 800;
}

.admin-ms-generate:disabled {
  cursor: wait;
  opacity: 0.65;
}

.admin-ms-message {
  flex-basis: 100%;
  margin: 0;
  color: #166534;
  font-size: 0.82rem;
  font-weight: 700;
}

.admin-ms-message.error {
  color: #b91c1c;
}

.admin-ms-drawer-enter-active,
.admin-ms-drawer-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.admin-ms-drawer-enter,
.admin-ms-drawer-leave-to {
  opacity: 0;
  transform: translateY(-0.35rem);
}

@media (max-width: 680px) {
  .admin-ms-tool {
    top: 0.75rem;
    right: 0.75rem;
    width: calc(100% - 1.5rem);
  }

  .admin-ms-panel {
    align-items: stretch;
    flex-direction: column;
  }

  .admin-ms-generate {
    width: 100%;
    min-width: 0;
  }
}
</style>
